import React, { useRef } from "react";
import type BaseObject from "../models/BaseObject";
import { useConnectionEndpoint } from "./useConnectionEndpoint";

/** Provides viewport anchors for a single equipment symbol in the embedded C1 plan. */
export function ConnectionEndpointGroup({ object, anchorSelector, ...props }: React.SVGProps<SVGGElement> & {
  object?: BaseObject;
  /** Measures the symbol itself when the group also contains labels or previews. */
  anchorSelector?: string;
}) {
  const element = useRef<SVGGElement>(null);
  useConnectionEndpoint(state.connectionAnalyser, object, element, "drawing", true, anchorSelector);
  return <g {...props} ref={element} />;
}
